import { Chart } from "@scuf/charts";
import { Card } from "@scuf/common";
import { useEffect, useState } from "react";
import { TostadorFetching } from "../../../class/fetchTostador";
import { plotBackground } from "../../../config/colors";
import { useDate } from "../../../hooks/useDate";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";

export default function PerfilUsoAgua() {
  const initialFetch = new TostadorFetching().setIdSeccion(2).setSecuencia(33);

  const defaultObject = Object.assign({
    value: [],
    fecha: [],
  });

  // Custom hook que nos ayuda a extraer la fecha inicial y final
  const { setDateHook, fullDate } = useDate();

  const [flujoAguaTE, setFlujoAguaTE] = useState(defaultObject);
  const [flujoAguaQuench, setFlujoAguaQuench] = useState(defaultObject);
  const [flujoAguaScrubber, setFlujoAguaScrubber] = useState(defaultObject);

  useEffect(() => {
    // Peticion de datos al API
    async function fetchData() {
      // Solo nos traemos la data de la peticion
      const { data } = await getValoresPeriodo(initialFetch);

      populateFlujoAguaTE(data);
      populateFlujoAguaScrubber(data);
      populateFlujoAguaQuench(data);
      setDateHook(data, "Flujo Agua a TE");
    }

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populateFlujoAguaScrubber(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Flujo de Agua a Scrubber"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setFlujoAguaScrubber({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateFlujoAguaQuench(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Flujo Agua a T. Quench"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setFlujoAguaQuench({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateFlujoAguaTE(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Flujo Agua a TE"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setFlujoAguaTE({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  return (
    <>
      <Card>
        <Card.Content>
          <Chart
            plotBackgroundColor={plotBackground}
            title={"Perfil de Uso Agua TE-T. Quench y Scrubber"}
            subtitle={"Periodo " + fullDate()}
          >
            {/** -------------------------------- Flujo Agua a T. Quench --------------------------------------- */}
            <Chart.Line
              name="Flujo Agua a T. Quench"
              data={flujoAguaQuench.value}
              yAxis={0}
            />

            {/** -------------------------------- Flujo de Agua a Scrubber --------------------------------------- */}
            <Chart.Line
              name="Flujo de Agua a Scrubber"
              data={flujoAguaScrubber.value}
              yAxis={0}
            />

            {/** -------------------------------- Flujo Agua a TE --------------------------------------- */}
            <Chart.Line
              name="Flujo Agua a TE"
              data={flujoAguaTE.value}
              yAxis={1}
            />

            {/** -------------------------------- FECHAS --------------------------------------- */}
            <Chart.XAxis categories={flujoAguaTE.fecha} />

            <Chart.YAxis
              labelSuffix=" m3/h"
              title="Caudal Agua a Scrubber y T. Quench"
              lineWidth={2}
              lineColor="white"
              min={0}
            />

            <Chart.YAxis
              labelSuffix=" m3/h"
              title="Flujo Agua a TE - PLG"
              lineWidth={2}
              lineColor="white"
              opposite={true}
              min={0}
            />

          </Chart>
        </Card.Content>
      </Card>
    </>
  );
}
